import { useState } from "react";
import {VideoCameraIcon } from "@heroicons/react/20/solid";
import { LoaderBlock } from "../../dashboard/components/LoaderBlock";
import { DefaultLoader } from "../../../stories/Loading.stories";
import { Loader } from "../../../components/loading/Loader";
import { SpinnerIcon } from "../../../components/loading/SpinnerIcon";

export const Thumbnail = ({ src, snapshotData }) => {

  const [hasError, setHasError] = useState(false);
  const [isEncoding, setIsEncoding] = useState(false);
  const [isShortifying, setIsShortifying] = useState(false);

  const handleOnError = () => {
    if (snapshotData?.video_encoding)
      setIsEncoding(true);
    else if (snapshotData?.video_shortifying)
      setIsShortifying(true);
    else
      setHasError(true);
  };

  return (
    <div className="relative w-full h-full overflow-hidden flex items-center justify-center">
      {
        hasError ?
          <>
            <VideoCameraIcon className="w-12 text-perception-gray-700"/>
          </>
        : isEncoding ?
          <div className="flex flex-col gap-4 mt-8 justify-center items-center text-center">
            <SpinnerIcon />
            <p>Vidéo en cours de traitement...</p>
          </div>
        : isShortifying ?
          <div className="flex flex-col gap-4 mt-8 justify-center items-center text-center">
            <SpinnerIcon />
            <p>Analyse en cours...</p>
          </div>
        :
          <img
            src={src}
            alt="thumbnail"
            style={{width: '100%', height: '100%', objectFit: 'cover', display: 'block'}}
            onError={handleOnError}
          />
      }
    </div>
  );
};